import script from "./form-dynamic-config-page.vue?vue&type=script&setup=true&lang=js"
export * from "./form-dynamic-config-page.vue?vue&type=script&setup=true&lang=js"

import "./form-dynamic-config-page.vue?vue&type=style&index=0&id=726bfd27&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726bfd27"]])

export default __exports__